import { useContext } from "react";
import Cabecalho from "../../components/Cabecalho";
import LinhaDado from "../../components/LinhaDado";
import Navbar from "../../components/Navbar/Navbar";
import { UserContext } from "../../context/UserContext";
import styles from "./styles.module.css";
import { useLocation } from "react-router-dom";
import ShowPlanoDeTrabalho from "../../components/ShowPlanoDeTrabalho";

const ContextoPlanoDeTrabalho = () => {
  const location = useLocation();
  const planoDeTrabalho = location.state.planoDeTrabalho;
  const metasFisicas = location.state.metasFisicas;
  const metasAplicacoes = location.state.metasAplicacoes;
  const metasAplicacaoRecurso = location.state.metasAplicacaoRecurso;
  const receitasDespesas = location.state.receitasDespesas;
  const equipamentos = location.state.equipamentos;
  const { idProposta, modalidade, title, icon, indexNavbar} = location.state;
  return (
    <div className={styles.page}>
      <Navbar activeIndex={indexNavbar} />
      <section>
        <Cabecalho
          title={`Detalhes do Projeto de ${title}`}
          icon={icon}
        />
        <main>
          <div className={styles.container}>
            <div>
              <ShowPlanoDeTrabalho
                descricao={planoDeTrabalho}
                metaFisica={metasFisicas}
                metasAplicacoes={metasAplicacoes}
                metasAplicacaoRecurso={metasAplicacaoRecurso}
                receitasDespesas={receitasDespesas}
                equipamentos={equipamentos}
              />
            </div>
          </div>
        </main>
      </section>
    </div>
  );
};

export default ContextoPlanoDeTrabalho;
